<template>
  <b-card header="Opciones de Filtro" class="card-filter">
    <b-btn class="filter-collapse" 
        variant="primary" 
        @click.prevent="showOpciones= !showOpciones">
      <i :class="showOpciones ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
    </b-btn>
    <b-collapse id="filtro" class="mt-2" v-model="showOpciones">
      <b-form>
        <b-form-group
          label="Desde"
          label-for="fechaDesde"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="fechaDesde" 
            v-model="filtro.fechaDesde" 
            type="date">
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Hasta"
          label-for="fechaHasta"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="fechaHasta" 
            v-model="filtro.fechaHasta" 
            type="date">
          </b-form-input>
        </b-form-group>

        <app-personal
          label="Personal"
          labelTodos="Todo el personal"
          :horizontal="Boolean(true)"
          :nullDisabled="Boolean(false)"
          :labelCols="labelCols"
          :nombre="personalNombre"
          :lista="personalList"
          @updated="personalActualizado">
        </app-personal>  

        <app-tipo-novedad
          label="Tipo de Novedad"
          labelTodos="Todos los tipos de novedad"
          :horizontal="Boolean(true)"
          :nullDisabled="Boolean(false)"
          :labelCols="labelCols"
          :nombre="tipoNovedadNombre"
          :lista="tiposNovedadesList"
          @updated="tipoNovedadActualizada">
        </app-tipo-novedad>  

        <div slot="footer">
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="filtrar">Filtrar</b-button>
        </div>
      </b-form>
    </b-collapse>
  </b-card>

</template>

<script>
import TipoNovedad from '../shared/abmSelect.vue';
import Personal from '../shared/abmSelect.vue';
import moment from 'moment';

export default {
  props: {
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
    personal: {
      type: Object,
      default: null
    },
    tipoNovedad: {
      type: Object,
      default: null
    },
  },
  components: {
    appTipoNovedad: TipoNovedad,
    appPersonal: Personal
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        tipoNovedad: null,
        personal: null,
      },
      showOpciones: Boolean(false),
      labelCols: 2,

      tiposNovedades: [],
      tiposNovedadesList: [],
      personel: [],
      personalList: [],
    }
  },
  created() {
      this.filtro.fechaDesde =  moment.utc(this.fechaDesde).format('YYYY-MM-DD');
      this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');

      this.getDatosAdicionales();
  },
  computed: {
    personalNombre() {
      if (this.filtro.personal) {
        if (this.filtro.personal.nombre) {
          return this.filtro.personal.nombre.trim();
        }
      }
      return null;
    },
    tipoNovedadNombre() {
      if (this.filtro.tipoNovedad) {
        if (this.filtro.tipoNovedad.nombre) {
          return this.filtro.tipoNovedad.nombre.trim();
        }
      }
      return null;
    }
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    getDatosAdicionales() {
      const vm = this;

      this.$store.dispatch('personel/getList', Boolean(false))
        .then(() => {
          vm.personel = this.$store.getters['personel/list'];
          vm.personalList = this.$store.getters['personel/selectList'];
        })
        .catch(() => this.showErrorMsj ('Se produjo un error al recuperar el listado de personal.'))

      this.$store.dispatch('tiposNovedades/getList')
        .then(() => {
          vm.tiposNovedades = this.$store.getters['tiposNovedades/list'];
          vm.tiposNovedadesList = this.$store.getters['tiposNovedades/selectList'];
        })
        .catch(() => this.showErrorMsj ('Se produjo un error al recuperar el listado de tipos de novedades.'))
    },
    tipoNovedadActualizada(tipoNovedadNombre) {
      this.filtro.tipoNovedad = this.getSelected(this.tiposNovedades, tipoNovedadNombre);
    },
    personalActualizado(personalNombre) {
      this.filtro.personal = this.getSelected(this.personel, personalNombre);
    },
  },
}
</script>

<style>
</style>
